import React, { Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from "react"
import "twin.macro"
import { emojis } from "./index"
import { EmojiReaction, useCreateReactionMutation } from "../../graphql/generated/graphql"
import { Authentication, AuthenticatonPage } from "../authentication"
import { AuthContext } from "../../utils/context"
import { Modal } from "../modal"
import { useEffectAsync } from "../../utils/hooks/useEffectAsync"

export interface EmojiPanelProps {
  questionId: string
  userEmoji: EmojiReaction | undefined
  setUserEmoji: React.Dispatch<React.SetStateAction<EmojiReaction | undefined>>
  showEmojiPanel: boolean
  setShowEmojiPanel: Dispatch<SetStateAction<boolean>>
  refetchQuestion: () => Promise<Record<string, any>>
}

export const EmojiPanel = (props: EmojiPanelProps) => {
  const { questionId, setShowEmojiPanel, setUserEmoji, userEmoji, refetchQuestion } = props
  const { token } = useContext(AuthContext)
  const [createReaction] = useCreateReactionMutation()
  const [showAuthenticationModal, setShowAuthenticationModal] = useState(false)
  const [isNotDismissable, setNotDismissable] = useState(false)
  const authenticationModalProps = {
    show: showAuthenticationModal,
    setShow: setShowAuthenticationModal,
    notDismissable: isNotDismissable,
    component: (
      <Authentication
        view={AuthenticatonPage.Join}
        setShow={setShowAuthenticationModal}
        setNotDismissable={setNotDismissable}
      />
    ),
  }

  const addReaction = (emoji: EmojiReaction) => {
    if (!token) {
      setShowAuthenticationModal(true)
    } else {
      setShowEmojiPanel(false)
      userEmoji === emoji ? setUserEmoji(undefined) : setUserEmoji(emoji)
    }
  }

  useEffectAsync(async () => {
    if (loaded.current) {
      await createReaction({ variables: { questionId, emoji: userEmoji } })
      await refetchQuestion()
    }
  }, [userEmoji])
  const loaded = useRef(false)
  useEffect(() => {
    loaded.current = true
  }, [])

  return (
    <>
      {emojis.map((emoji) => (
        <div
          tw="cursor-pointer transition-all hover:scale-125"
          key={emoji.key}
          onClick={() => addReaction(emoji.key)}
          aria-label={`add ${emoji.key}`}
        >
          <span tw="cursor-pointer" data-testid={`reaction-${emoji.key}`}>{`${emoji.value}`}</span>
        </div>
      ))}
      <Modal {...authenticationModalProps} />
    </>
  )
}
